import React, { createContext, useMemo, useState } from 'react';

export const GeoLocationContext = createContext(null);

export const GeoLocationProvider = ({ children, ssrLocation = '' }) => {
  const [location, setLocation] = useState(ssrLocation || '');

  const updateLocation = (locationValue) => {
    setLocation(typeof locationValue === 'string' ? locationValue : '');
  };

  const value = useMemo(() => ({ location, updateLocation }), [location]);
  return <GeoLocationContext.Provider value={value}>{children}</GeoLocationContext.Provider>;
};

